module.exports = __webpack_public_path__ + "img/badge-expiredate.0cf04db9.svg";